import { useState, useEffect } from "react";
import { useDocuments } from "./useDocuments";

export const useEnrichedComments = (comentarios) => {
  const [comentariosEnriched, setComentariosEnriched] = useState([]);
  const { getFilesBatch } = useDocuments();

  useEffect(() => {
    const loadCommentDocuments = async () => {
      try {
        if (!comentarios?.length) {
          setComentariosEnriched([]);
          return;
        }

        const allFileIds = comentarios
          .flatMap((c) => c.files || [])
          .map((f) => Number(f.fileId ?? f.id))
          .filter((id) => !Number.isNaN(id));

        if (!allFileIds.length) {
          setComentariosEnriched(comentarios);
          return;
        }

        const files = await getFilesBatch(allFileIds);
        const fileMap = files.reduce((acc, f) => {
          acc[f.id] = f;
          return acc;
        }, {});

        const enriched = comentarios.map((comentario) => {
          if (!comentario.files?.length) return comentario;
          const mergedFiles = comentario.files.map((doc) => {
            const fileId = Number(doc.fileId ?? doc.id);
            const storageFile = fileMap[fileId];
            return {
              ...doc,
              id: fileId,
              fileId,
              name: storageFile?.name || storageFile?.filename || "Documento",
              url: storageFile?.url || null,
              hash: storageFile?.hash ?? null,
            };
          });
          return { ...comentario, files: mergedFiles };
        });

        setComentariosEnriched(enriched);
      } catch (error) {
        console.error("Error loading comment documents:", error);
        setComentariosEnriched(comentarios);
      }
    };

    loadCommentDocuments();
  }, [comentarios]);

  return { comentariosEnriched };
};